var React = require('react');

function HomeAndContents (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 4.2L29 17.2V30.8H3V17.2L16 4.2ZM16 0L0 16V33.8H32V16L16 0Z","fill":"#34363E","key":0}),React.createElement("path",{"d":"M16 17.6001H5.40002V26.4001H16V17.6001Z","fill":"#34363E","key":1}),React.createElement("path",{"d":"M22.2001 26.6001C24.6301 26.6001 26.6001 24.6301 26.6001 22.2C26.6001 19.77 24.6301 17.8 22.2001 17.8C19.77 17.8 17.8 19.77 17.8 22.2C17.8 24.6301 19.77 26.6001 22.2001 26.6001Z","fill":"#34363E","key":2})]);
}

HomeAndContents.defaultProps = {"width":"32","height":"34","viewBox":"0 0 32 34","fill":"none"};

module.exports = HomeAndContents;

HomeAndContents.default = HomeAndContents;
